<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1000px; min-height: 400px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            設定群組人員
          </p>
        </header>

        <section class="modal-card-body">
          <form-group>
            <b-taginput
              v-model="groupEmployees"
              :loading="isLoading"
              :data="filteredEmployees"
              autocomplete
              field="name"
              placeholder="輸入員工編號或姓名找尋對象"
              :allow-duplicates="false"
              @typing="filterEmployees"
            >
              <template v-slot="props">
                [{{ props.option.emp_code }}] {{ props.option.name }}
              </template>
              <template #empty>
                未選擇
              </template>
            </b-taginput>
          </form-group>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading
          :active.sync="isLoading"
          :is-full-page="false"
          :can-cancel="false"
        ></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { EMPLOYEES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'

export default {
  name: 'GroupEmployeesForm',

  props: {
    permissionGroup: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      employees: [],
      filteredEmployees: [],

      groupEmployees: []
    }
  },
  computed: {
    isLoading() {
      return this.loading || this.sending
    }
  },
  mounted() {
    this.fetchEmployees()
  },
  methods: {
    async fetchEmployees() {
      try {
        const api = `${EMPLOYEES_API}/list`

        this.loading = true
        const res = await this.axios.get(api)
        this.employees = res.data.data
        this.setupGroupEmployeesList()
      } catch (e) {
        this.employees = []
        this.groupEmployees = []

        notifyService.fetch_error('employee', e)
      } finally {
        this.loading = false
      }
    },
    setupGroupEmployeesList() {
      const employees = this.permissionGroup.employees.map(e => e.emp_code)

      this.groupEmployees = this.employees
        .filter(e => employees.includes(e.emp_code))
        .sort(e => e.emp_code)
        .sort((e1, e2) => e2.status - e1.status)
    },
    filterEmployees: debounce(function(search) {
      this.filteringEmployeesAsync(search)
    }, 1000),
    async filteringEmployeesAsync(search) {
      if (!search) {
        this.filteredEmployees = []
        return
      }

      this.filteredEmployees = this.employees.filter(
        e => e.name.includes(search) || e.emp_code.startsWith(search)
      )
    },
    async onSend() {
      const employees = this.groupEmployees
        .sort(e => e.emp_code)
        .sort((e1, e2) => e2.status - e1.status)
        .map(e => e.emp_code)

      this.$emit('send', this.permissionGroup.id, { employees })
    }
  }
}
</script>
